<ds-themed-status-badge [object]="object"></ds-themed-status-badge>
<ng-container *ngIf="myDSpaceStatus">
    <ds-themed-my-dspace-status-badge [status]="myDSpaceStatus"></ds-themed-my-dspace-status-badge>
</ng-container>
<ds-themed-type-badge [object]="object"></ds-themed-type-badge>
